var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "#FFC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33017 14.174L12.939 9.5652C13.1485 9.34472 13.4382 9.21816 13.7423 9.21424C14.0464 9.21032 14.3393 9.32932 14.5544 9.54428C14.7696 9.7593 14.8889 10.052 14.8852 10.3562C14.8816 10.6603 14.7553 10.9501 14.535 11.1598L11.8106 13.88H20.8714C21.2745 13.88 21.647 14.0951 21.8486 14.4442C22.0502 14.7933 22.0502 15.2235 21.8486 15.5726C21.647 15.9217 21.2745 16.1368 20.8714 16.1368H11.8358L14.535 18.8402C14.8081 19.1276 14.9104 19.5372 14.8044 19.9191C14.6984 20.3011 14.3998 20.5995 14.0177 20.7052C13.6356 20.8108 13.2261 20.7081 12.939 20.4348L8.33016 15.826C8.11774 15.6149 7.99875 15.3275 7.99976 15.028C7.99903 15.0187 7.99903 15.0093 7.99976 15C7.99907 14.9907 7.99907 14.9813 7.99976 14.972C7.99985 14.6727 8.11871 14.3857 8.33017 14.174Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.079bce0762eeda4cbf3cabc4f7734e30.svg";
export { ForwardRef as ReactComponent };